<script lang="ts">
import { defineComponent as __MACROS_defineComponent } from "vue";
export default /*#__PURE__*/ __MACROS_defineComponent({
  name: 'FormationsUiUxDesign'
});
</script>
<template>
  <ka-container
    code="prog-10-ui-ux-design"
    :data="page.$info.prog10UiUxDesign">
    <!-- Page formation - V -->
    <ka-container code="page-formation-v">
      <PFormationEntete
        instance-class="p-formation-entete--p54"
        h-1="Formation en UI/UX design"
        texte="La formation est réalisée par un<strong> expert en UI/UX design</strong> issu d'une entreprise à succès." />
      <!-- Container programme -->
      <ka-container code="container-programme">
        <!-- Container gauche -->
        <ka-container code="container-gauche">
          <!-- Container programme de formation -->
          <ka-container code="container-programme-de-formation">
            <!-- Titre exemple de programme -->
            <ka-container code="titre-exemple-de-programme">
              <ka-text code="voici-un-exemple-de">
                <h2 v-html="t('prog10UiUxDesign.pageFormationV.containerProgramme.containerGauche.containerProgrammeDeFormation.titreExempleDeProgramme.voiciUnExempleDe.value', `Voici un exemple de programme de formation`)" />
              </ka-text>
            </ka-container>
            <!-- Module1 -->
            <ka-container code="module-1">
              <ka-text code="acquerir-les-bases">
                <h2 v-html="t('prog10UiUxDesign.pageFormationV.containerProgramme.containerGauche.containerProgrammeDeFormation.module1.acquerirLesBases.value', `Acquérir les bases pour une conception centrée utilisateurs`)" />
              </ka-text>
              <!-- Container -->
              <ka-container code="container-1" />
            </ka-container>
            <!-- Sections déroulantes -->
            <ka-container code="sections-deroulantes">
              <!-- Conteneur section -->
              <ka-container code="conteneur-section">
                <DropDownFormation
                  instance-class="drop-down-formation--p54"
                  titre="I.    L’ergonomie de votre site web"
                  :arguments="page.$constants.dropDownFormationArguments" />
              </ka-container>
              <!-- Conteneur section -->
              <ka-container code="container-2">
                <DropDownFormation
                  instance-class="element-4--p54"
                  titre="II.   L’interface"
                  :arguments="page.$constants.element4Arguments" />
              </ka-container>
            </ka-container>
            <!-- Module2 -->
            <ka-container code="module-2">
              <!-- Container -->
              <ka-container code="container-3" />
              <ka-text code="lui-ux-appliquee-a">
                <h2 v-html="t('prog10UiUxDesign.pageFormationV.containerProgramme.containerGauche.containerProgrammeDeFormation.module2.luiUxAppliqueeA.value', `L’UI/UX appliquée à son activité`)" />
              </ka-text>
            </ka-container>
            <!-- Sections déroulantes -->
            <ka-container code="container-4">
              <!-- Conteneur section -->
              <ka-container code="container-5">
                <DropDownFormation
                  instance-class="element-5--p54"
                  titre="I.    L’organisation et les contenus"
                  :arguments="page.$constants.element5Arguments" />
              </ka-container>
              <!-- Conteneur section -->
              <ka-container code="container-6">
                <DropDownFormation
                  instance-class="element-6--p54"
                  titre="II.   L’interface"
                  :arguments="page.$constants.element6Arguments" />
              </ka-container>
            </ka-container>
            <!-- Module3 -->
            <ka-container code="module-3">
              <!-- Container -->
              <ka-container code="container-7" />
              <ka-text code="realiser-des-tests">
                <h2 v-html="t('prog10UiUxDesign.pageFormationV.containerProgramme.containerGauche.containerProgrammeDeFormation.module3.realiserDesTests.value', `Réaliser des tests utilisateurs`)" />
              </ka-text>
            </ka-container>
            <!-- Sections déroulantes -->
            <ka-container code="container-8">
              <!-- Conteneur section -->
              <ka-container code="container-9">
                <DropDownFormation
                  instance-class="element-7--p54"
                  titre="I.    Mettre en place un test utilisateur"
                  :arguments="page.$constants.element7Arguments" />
              </ka-container>
            </ka-container>
          </ka-container>
          <CtaProgrammeSurMesurePrendreRdv instance-class="cta-programme-sur-mesure-prendre-rdv--p54" />
        </ka-container>
        <BlocArgCtaRdvPedagogieMatchers
          instance-class="bloc-arg-cta-rdv-pedagogie-matchers--p54"
          :xs="{ hidden: null }"
          expert-1="https://ucarecdn.com/317c648e-e707-43df-8f87-df66b9823bdf/profil_expert_Anne-Sophie.svg" />
      </ka-container>
      <BlocArgPasDeFraisPasDeDemarchesAdministratives instance-class="bloc-arg-pas-de-frais-pas-de-demarches-admi--p54" />
      <PFormationMatching instance-class="p-formation-matching--p54" />
      <PFormationCriteresQualiopi instance-class="p-formation-criteres-qualiopi--p54" />
    </ka-container>
  </ka-container>
</template>

<route>
{
  "meta": {
    "layout": "Header:Footer"
  }
}
</route>

<script setup lang="ts">
import { generateMeta, syncPageStore } from 'kapix-components-vue3'
import { formationsUiUxDesign } from './store'
import BlocArgCtaRdvPedagogieMatchers from '~/components/BlocArgCtaRdvPedagogieMatchers/index.vue'
import BlocArgPasDeFraisPasDeDemarchesAdministratives from '~/components/BlocArgPasDeFrais/PasDeDemarchesAdministratives/index.vue'
import CtaProgrammeSurMesurePrendreRdv from '~/components/CtaProgrammeSurMesurePrendreRdv/index.vue'
import DropDownFormation from '~/components/DropDownFormation/index.vue'
import PFormationCriteresQualiopi from '~/components/PFormationCriteresQualiopi/index.vue'
import PFormationEntete from '~/components/PFormationEntete/index.vue'
import PFormationMatching from '~/components/PFormationMatching/index.vue'
import { appDataStore } from '~/stores'
import './style.scss'
import './style.custom.scss'


provide('$scoped', '--p54')
const appData = appDataStore()
const page = formationsUiUxDesign()
const props = withDefaults(defineProps<{
  seo?: Nullable<boolean>
}>(), {
  seo: true
})

syncPageStore(page)
// SEO
if (props.seo) {
  // https://github.com/vueuse/head
  useHead({
    title: computed(() => page.$title),
    htmlAttrs: { lang: appData.locale },
    meta: computed(() => generateMeta({
      title: page.$title,
      description: page.$description,
      canonicalUrl: appData.hostname,
      publishedTime: page.$publishedTime,
      modifiedTime: page.$modifiedTime,
      ...appData.twitter
    }))
  })

  useSchemaOrg([
    // https://vue-schema-org.netlify.app/api/schema/webpage.html#type-definition
    defineWebPage({
      name: page.$title,
      description: page.$description,
      inLanguage: appData.locale,
      primaryImageOfPage: appData.twitter.image,
      datePublished: page.$publishedTime
      // dateModified: page.$modifiedTime?.toISOString()
    })
  ])
}
</script>
